<script setup>
defineEmits([
  'click',
])
</script>

<template>
  <menu
    :class="$style.menu"
    @click="$emit('click', $event)"
  >
    <slot />
  </menu>
</template>

<style module>
.menu {
  display: flex;
  flex-direction: column;
  min-width: 8rem;
  max-height: calc(400px + 2 * 0.5rem);
  padding: 0;
  border-radius: var(--border-radius-m);
  background-color: var(--bg-page-element);
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 767px) {
    position: fixed;
    top: var(--topbar-height);
    left: 0;
    width: 100vw;
    height: calc(100vh - var(--topbar-height));
    max-height: none;
    border-radius: 0;
  }
}
</style>
